<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-6">
<p class="centerImage"><img alt="image" src="images/img13.jpg" style="max-width: 100%"/></p>
<p class="caption"><em class="italic">Silver Street, one of the main thoroughfares in Frenchville, destroyed by the French raid of 1377. Today called Newtown, it is a bird sanctuary and nature trail. </em><span class="smallcaps">Carol Trow</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_ch16.vue?16374dbb